const LOCAL_PATH = /^\/(?![/\\])/

const ORIGIN = 'http://orbitid.invalid'

export const safeRedirectPath = (value: unknown, fallback = '/') => {
  if (typeof value !== 'string' || !LOCAL_PATH.test(value)) return fallback

  const url = new URL(value, ORIGIN)
  if (url.origin !== ORIGIN) return fallback

  return `${url.pathname}${url.search}${url.hash}`
}
